import React from "react";
import * as Icon from "react-feather";
import { all_routes } from "Router/all_routes";

export const SidebarData = [
  {
    label: "",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "",
    submenuItems: [
      {
        label: "Dashboard",
        link: "/Dashboard",
        icon: <Icon.Grid />,
        submenu: false,
        showSubRoute: false,
        accessCode: "Dashboard",
      },

      {
        label: "Human Resources",
        link: "#",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: true,
        accessCode: "Human Resources",
        submenuItems: [
          {
            label: "Employee Directory",
            link: "/Employee/EmployeeDirectory",
            icon: <Icon.User />,
            showSubRoute: false,
            accessCode: "Employee Directory",
          },
          {
            label: "Departments",
            link: "/Employee/Department/DepartmentList",
            icon: <Icon.User />,
            showSubRoute: false,
            accessCode: "Departments",
          },
          {
            label: "Designations",
            link: "/Employee/Designation/DesignationList",
            icon: <Icon.UserCheck />,
            showSubRoute: false,
            accessCode: "Designations",
          },

          {
            label: "Allowance & Deductions",
            link: "/Employee/AllowanceAndDeductions",
            icon: <Icon.User />,
            showSubRoute: false,
            accessCode: "Allowances & Deductions",
          },
          {
            label: "Employee Working Hours",
            link: "/Employee/EmpWorkingHours",
            icon: <Icon.UserCheck />,
            showSubRoute: false,
            accessCode: "Employee Working Hours",
          },
          {
            label: "KET",
            link: "/Employee/KET/KETInformation",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Employee Directory",
          },
          {
            label: "Contract",
            link: "/Employee/Contract/ContractList",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Employee Directory",
          },
        ],
      },
      {
        label: "Compensation Adjustments",
        link: "#",
        icon: <Icon.Calendar />,
        showSubRoute: false,
        submenu: true,
        accessCode: "Compensation Adjustments",
        submenuItems: [
          {
            label: "Leave Management",
            link: "/Leave/LeaveManagement",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Leave Management",
          },
          {
            label: "Leave Categories",
            link: "/Leave/LeaveType",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Leave Categories",
          },
          {
            label: "Employee Leave Records",
            link: "/Leave/EmployeeLeave",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Employee Leave Records",
          },
          {
            label: "Holiday Calendar",
            link: "/Leave/PublicHoliday",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Holiday Calendar",
          },
        ],
      },
      {
        label: "Time & Attendance",
        link: "#",
        icon: <Icon.Clock />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Time & Attendance",
        submenuItems: [
          {
            label: "Time Tracking",
            // link: "/Attendance/AttendanceManagement",
            link: "/Attendance/TimeLog",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Time Tracking",
          },
          // {
          //   label: "Attendance Management",
          //   // link: "/Attendance/AttendanceManagement",
          //   link: "/Attendance/Attendance-Filter",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Attendance Management",
          // },
          // {
          //   label: "Shift Policy",
          //   icon: <Icon.Settings />,
          //   link: "/Company/Setting/Shift/Shift-Policy",
          //   showSubRoute: true,
          // },
          {
            label: "Timesheet",
            link: "/Attendance/Timesheet",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Timesheet Management",
          },
          {
            label: "Attendance QR Code",
            link: "/Attendance/AttendanceQRCode",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Timesheet Management",
          },
        ],
      },
      {
        label: "Project Management",
        link: "#",
        icon: <Icon.FileText />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Project Management",
        submenuItems: [
          {
            label: "Project Portfolio",
            link: "/Project/Project",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Project Portfolio",
          },
          {
            label: "Task Assignments",
            link: "/Project/Task",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Task Assignments",
          },
        ],
      },
      {
        label: "Shift Management",
        link: "#",
        icon: <Icon.Clock />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Shift Management",
        submenuItems: [
          {
            label: "Shift Policies",
            icon: <Icon.Settings />,
            link: "/Shift/Shift-Policy",
            showSubRoute: true,
            accessCode: "Shift Policies",
          },
          {
            label: "Shift Scheduling",
            icon: <Icon.Settings />,
            link: "/Shift/Shift-Rotation",
            showSubRoute: true,
            accessCode: "Shift Scheduling",
          },
          {
            label: "Employee Shift Mapping",
            icon: <Icon.Settings />,
            link: "/Shift/Employee-Shift-Mapping",
            showSubRoute: true,
            accessCode: "Employee Shift Mapping",
          },
        ],
      },
      {
        label: "Claims Processing",
        link: "#",
        icon: <Icon.FileText />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Claims Processing",
        submenuItems: [
          {
            label: "Claim Categories",
            link: "/Claim/Type/Claim-Type",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Claim Categories",
          },
          {
            label: "Manage Claims",
            link: "/Claim/Manage/Claim-List",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Manage Claims",
          },
        ],
      },

      {
        label: "Payroll Management",
        link: "#",
        icon: <Icon.DollarSign />,
        showSubRoute: false,
        submenu: true,
        accessCode: "Payroll Management",
        submenuItems: [
          {
            label: "Payroll Generation",
            link: "/Payroll/GeneratePayroll",
            showSubRoute: false,
            accessCode: "Payroll Generation",
          },
          {
            label: "Payroll Processing Stages",
            link: "/Payroll/PayrollStage",
            showSubRoute: false,
            accessCode: "Payroll Processing Stages",
          },
          {
            label: "Payroll Records",
            link: "/Payroll/PayrollList",
            showSubRoute: false,
            accessCode: "Payroll Records",
          },
          {
            label: "Allowance Management",
            link: "/Payroll/Addition",
            showSubRoute: false,
            accessCode: "Allowance Management",
          },
          {
            label: "Deduction Management",
            link: "/Payroll/Deduction",
            showSubRoute: false,
            accessCode: "Deduction Management",
          },

          // {
          //   label: "Bank Payment List",
          //   link: "/Payroll/BankPaymentList",
          //   icon: <Icon.File />,
          //   showSubRoute: false,
          //   accessCode: "Payroll Records",
          // },
        ],
      },
      {
        label: "Loans & Advances",
        link: "#",
        icon: <Icon.FileText />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Loans & Advances",
        submenuItems: [
          {
            label: "Advance Disbursement",
            link: "/LoanAndAdvance/Advance-Payment/Advance-Payment-List",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Advance Disbursement",
          },
        ],
      },
      // {
      //   label: "Government",
      //   link: "#",
      //   icon: <Icon.FileText />,
      //   submenu: true,
      //   showSubRoute: false,
      //   accessCode: "Settings",
      //   submenuItems: [
      //     {
      //       label: "IRAS",
      //       icon: <Icon.Settings />,
      //       submenu: true,
      //       showSubRoute: false,
      //       accessCode: "Users",
      //       submenuItems: [
      //         {
      //           label: "IR8A Form",
      //           link: "/Government/IRAS/IR8A/IR8AFormList",
      //           showSubRoute: false,
      //           accessCode: "UsersMaster",
      //         },

      //         // {
      //         //   label: "IR8A eSubmission",
      //         //   link: "/Government/IRAS/IR8A-eSubmission",
      //         //   showSubRoute: false,
      //         //   accessCode: "Users Groups",
      //         // },
      //         {
      //           label: "IR8S Form",
      //           link: "/Government/IRAS/IR8S-Form",
      //           showSubRoute: false,
      //           accessCode: "UsersMaster",
      //         },
      //         // {
      //         //   label: "IR8S eSubmission",
      //         //   link: "/Government/IRAS/IR8S-eSubmission",
      //         //   showSubRoute: false,
      //         //   accessCode: "Users Groups",
      //         // },
      //         {
      //           label: "Appendix 8A Form",
      //           link: "/Government/IRAS/Appendix-8A-Form",
      //           showSubRoute: false,
      //           accessCode: "UsersMaster",
      //         },

      //         // {
      //         //   label: "Appendix 8A eSubmission",
      //         //   link: "/Government/IRAS/Appendix-8A-eSubmission",
      //         //   showSubRoute: false,
      //         //   accessCode: "Users Groups",
      //         // },
      //         {
      //           label: "Appendix 8B Form",
      //           link: "/Government/IRAS/Appendix-8B-Form",
      //           showSubRoute: false,
      //           accessCode: "UsersMaster",
      //         },

      //         // {
      //         //   label: "Appendix 8B eSubmission",
      //         //   link: "/Government/IRAS/Appendix-8B-eSubmission",
      //         //   showSubRoute: false,
      //         //   accessCode: "Users Groups",
      //         // },
      //       ],
      //     },
      //   ],
      // },
      {
        label: "Others",
        link: "#",
        icon: <Icon.FileText />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Vehicle Management",
        submenuItems: [
          {
            label: "Vehicle",
            link: "/Master/Vehicle/VehicleInformation",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Vehicle Registry",
          },
          {
            label: "Contract",
            icon: <Icon.Settings />,
            submenu: true,
            showSubRoute: false,
            accessCode: "Master",
            submenuItems: [
              {
                label: "Contract Master",
                link: "/Company/Setting/Master/ContractType",
                showSubRoute: false,
                accessCode: "ContarctType",
              },
              {
                label: "Contract Template",
                link: "/Company/Setting/Master/ContractTemplate",
                showSubRoute: false,
                accessCode: "ContarctType",
              },
            ],
          },
        ],
      },
      {
        label: "Reports",
        icon: <Icon.File />,
        link: "/Report/Report-List",
        submenu: false,
        accessCode: "Report",
      },

      {
        label: "Setting",
        link: "#",
        icon: <Icon.Settings />,
        showSubRoute: false,
        submenu: true,
        accessCode: "Settings",
        submenuItems: [
          {
            label: "Company Settings",
            icon: <Icon.Settings />,
            link: "/Company/Setting/Company-Setting",
            showSubRoute: false,
            accessCode: "CompanySetting",
          },
          {
            label: "Email Alert Configuration",
            icon: <Icon.Settings />,
            link: "/Company/Setting/Email-Alert-Configuration",
            showSubRoute: false,
            accessCode: "Email Alert Configuration",
          },
          {
            label: "Users",
            icon: <Icon.Settings />,
            // link: "/Company/Setting/User",
            submenu: true,
            showSubRoute: false,
            accessCode: "Users",
            submenuItems: [
              // {
              //   label: "Employee Login",
              //   link: "/Company/Setting/User/Employee-Master/List",
              //   showSubRoute: false,
              //   accessCode: "Payroll Generation",
              // },
              {
                label: "Users",
                link: "/Company/Setting/User/User-Master/List",
                showSubRoute: false,
                accessCode: "UsersMaster",
              },

              {
                label: "User Groups",
                link: "/Company/Setting/User/User-Group/List",
                showSubRoute: false,
                accessCode: "Users Groups",
              },
              // {
              //   label: "Role Management",
              //   link: "/Company/Setting/User/User-Roles",
              //   showSubRoute: false,
              // },
              // {
              //   label: "Level 2.2",
              //   submenu: true,
              //   showSubRoute: false,
              //   // submenuItems: [
              //   //   { label: "Level 3.1", link: "#", showSubRoute: false },
              //   //   { label: "Level 3.2", link: "#", showSubRoute: false },
              //   // ],
              // },
            ],
          },
          {
            label: "Master",
            icon: <Icon.Settings />,
            link: "/Company/Setting/Master",
            showSubRoute: false,
            accessCode: "Master",
          },
          {
            label: "Announcement",
            link: "/Company/Announcement/AnnouncementList",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "CompanySetting",
          },
          {
            label: "Audit Log",
            icon: <Icon.Settings />,
            link: "/Company/Setting/Audit-Log",
            showSubRoute: false,
            accessCode: "CompanySetting",
          },
        ],
      },
    ],
  },
];

export const ReportSidebarData = [
  {
    label: "Main",
    submenuOpen: true,
    showSubRoute: true,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Home",
        link: "/Dashboard",
        icon: <Icon.Home />,
        showSubRoute: false,
        accessCode: "Dashboard",
      },
      {
        label: "Reports",
        submenuOpen: true,
        showSubRoute: false,
        submenuHdr: "Reports",
        icon: <Icon.File />,
        link: "#",
        submenu: true,
        accessCode: "Report",
        submenuItems: [
          {
            label: "Human Resources",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            icon: <Icon.File />,
            link: "#",
            submenu: true,
            accessCode: "Report",
            submenuItems: [
              {
                label: "Employee Details Report",
                link: "/Report/Employee-Details-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Employee Details Report",
              },
              {
                label: "Employee Count Report",
                link: "/Report/Employee-Count-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Employee Details Report",
              },
            ],
          },
          {
            label: "Compensation & Advances",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            icon: <Icon.File />,
            link: "#",
            submenu: true,
            accessCode: "Report",
            submenuItems: [
              {
                label: "Addition / Deduction Report",
                link: "/Report/Addition-Deduction-Report",
                icon: <Icon.BarChart2 />,
                showSubRoute: false,
                accessCode: "Addition / Deduction Report",
              },
              {
                label: "Advance Payment Report",
                link: "/Report/Advance-Payment-Report",
                icon: <Icon.BarChart2 />,
                showSubRoute: false,
                accessCode: "Advance Payment Report",
              },
              {
                label: "Advance Repayment Report",
                link: "/Report/Advance-Repayment-Report",
                icon: <Icon.BarChart2 />,
                showSubRoute: false,
                accessCode: "Advance Repayment Report",
              },
            ],
          },
          {
            label: "Workforce Management",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            icon: <Icon.File />,
            link: "#",
            submenu: true,
            accessCode: "Report",
            submenuItems: [
              {
                label: "Attendance Report",
                link: "/Report/Attendance-Report",
                icon: <Icon.BarChart2 />,
                showSubRoute: false,
                accessCode: "Employee Attendance Report",
              },
              // {
              //   label: "Leave Report",
              //   link: "/Report/Leave-Report",
              //   icon: <Icon.PieChart />,
              //   showSubRoute: false,
              //   accessCode: "Leave Utilization Report",
              // },
              {
                label: "Leave History Report",
                link: "/Report/Leave-History-Report",
                icon: <Icon.PieChart />,
                showSubRoute: false,
                accessCode: "Employee Leave History",
              },
            ],
          },
          {
            label: "Payroll Insights",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            icon: <Icon.File />,
            link: "#",
            submenu: true,
            accessCode: "Report",
            submenuItems: [
              {
                label: "Monthly Payroll Summary",
                link: "/Report/Monthly-Payroll-Summary",
                icon: <Icon.Inbox />,
                showSubRoute: false,
                accessCode: "Monthly Payroll Summary",
              },
              {
                label: "Payslip Report",
                link: "/Report/Payslip-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Payroll Forecast Report",
              },
              {
                label: "Payroll Forecast Report",
                link: "/Report/Forecast-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Payroll Forecast Report",
              },
              {
                label: "Levy Report",
                link: "/Report/Levy-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Payroll Forecast Report",
              },
            ],
          },

          {
            label: "Contractual & Compliance",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            icon: <Icon.File />,
            link: "#",
            submenu: true,
            accessCode: "Report",
            submenuItems: [
              {
                label: "Employment Contract Overview",
                link: "/Report/Contract-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Employment Contract Overview",
              },
              {
                label: "Document Expiry Report",
                link: "/Report/Expiry-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Document Expiry Report",
              },
              {
                label: "Project Man-Hour Analysis",
                link: "/Report/Man-Hour-Project-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Project Man-Hour Analysis",
              },
              // {
              //   label: "Daily Work Order Report",
              //   link: "/Report/Daily-Work-Order-Report",
              //   icon: <Icon.File />,
              //   showSubRoute: false,
              //   accessCode: "Daily Work Order Report",
              // },
            ],
          },
          {
            label: "Project Report",
            submenuOpen: true,
            showSubRoute: false,
            submenuHdr: "Reports",
            icon: <Icon.File />,
            link: "#",
            submenu: true,
            accessCode: "Project Report",
            submenuItems: [
              {
                label: "Project Report",
                link: "/Report/Project-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Project Report",
              },
              {
                label: "Project Costing Report",
                link: "/Report/Project-Costing-Report",
                icon: <Icon.File />,
                showSubRoute: false,
                accessCode: "Project Report",
              },
            ],
          },
        ],
      },
    ],
  },
];

export const SidebarDataForAllCompanies = [
  {
    label: "",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "",
    submenuItems: [
      {
        label: "Dashboard",
        link: "/Dashboard",
        icon: <Icon.Grid />,
        submenu: false,
        showSubRoute: false,
        accessCode: "Dashboard",
      },

      {
        label: "Human Resources",
        link: "#",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: true,
        accessCode: "Human Resources",
        submenuItems: [
          {
            label: "Employee Directory",
            link: "/Employee/EmployeeDirectory",
            icon: <Icon.User />,
            showSubRoute: false,
            accessCode: "Employee Directory",
          },
          // {
          //   label: "Departments",
          //   link: "/Employee/Department/DepartmentList",
          //   icon: <Icon.User />,
          //   showSubRoute: false,
          //   accessCode: "Departments",
          // },
          // {
          //   label: "Designations",
          //   link: "/Employee/Designation/DesignationList",
          //   icon: <Icon.UserCheck />,
          //   showSubRoute: false,
          //   accessCode: "Designations",
          // },

          // {
          //   label: "Allowance & Deductions",
          //   link: "/Employee/AllowanceAndDeductions",
          //   icon: <Icon.User />,
          //   showSubRoute: false,
          //   accessCode: "Allowances & Deductions",
          // },
          // {
          //   label: "Employee Working Hours",
          //   link: "/Employee/EmpWorkingHours",
          //   icon: <Icon.UserCheck />,
          //   showSubRoute: false,
          //   accessCode: "Employee Working Hours",
          // },
          // {
          //   label: "KET",
          //   link: "/Employee/KET/KETInformation",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Employee Directory",
          // },
        ],
      },
      {
        label: "Compensation Adjustments",
        link: "#",
        icon: <Icon.Calendar />,
        showSubRoute: false,
        submenu: true,
        accessCode: "Compensation Adjustments",
        submenuItems: [
          {
            label: "Leave Management",
            link: "/Leave/LeaveManagement",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Leave Management",
          },
          // {
          //   label: "Leave Categories",
          //   link: "/Leave/LeaveType",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Leave Categories",
          // },
          {
            label: "Employee Leave Records",
            link: "/Leave/EmployeeLeave",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Employee Leave Records",
          },
          // {
          //   label: "Holiday Calendar",
          //   link: "/Leave/PublicHoliday",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Holiday Calendar",
          // },
        ],
      },
      {
        label: "Time & Attendance",
        link: "#",
        icon: <Icon.Clock />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Time & Attendance",
        submenuItems: [
          // {
          //   label: "Time Tracking",
          //   // link: "/Attendance/AttendanceManagement",
          //   link: "/Attendance/TimeLog",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Time Tracking",
          // },
          // {
          //   label: "Attendance Management",
          //   // link: "/Attendance/AttendanceManagement",
          //   link: "/Attendance/Attendance-Filter",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Attendance Management",
          // },
          // {
          //   label: "Shift Policy",
          //   icon: <Icon.Settings />,
          //   link: "/Company/Setting/Shift/Shift-Policy",
          //   showSubRoute: true,
          // },
          {
            label: "Timesheet",
            link: "/Attendance/Timesheet",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Timesheet Management",
          },
          {
            label: "Attendance QR Code",
            link: "/Attendance/AttendanceQRCode",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Timesheet Management",
          },
        ],
      },
      {
        label: "Project Management",
        link: "#",
        icon: <Icon.FileText />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Project Management",
        submenuItems: [
          {
            label: "Project Portfolio",
            link: "/Project/Project",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Project Portfolio",
          },
          {
            label: "Task Assignments",
            link: "/Project/Task",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Task Assignments",
          },
        ],
      },
      // {
      //   label: "Shift Management",
      //   link: "#",
      //   icon: <Icon.Clock />,
      //   submenu: true,
      //   showSubRoute: false,
      //   accessCode: "Shift Management",
      //   submenuItems: [
      //     {
      //       label: "Shift Policies",
      //       icon: <Icon.Settings />,
      //       link: "/Shift/Shift-Policy",
      //       showSubRoute: true,
      //       accessCode: "Shift Policies",
      //     },
      //     {
      //       label: "Shift Scheduling",
      //       icon: <Icon.Settings />,
      //       link: "/Shift/Shift-Rotation",
      //       showSubRoute: true,
      //       accessCode: "Shift Scheduling",
      //     },
      //     {
      //       label: "Employee Shift Mapping",
      //       icon: <Icon.Settings />,
      //       link: "/Shift/Employee-Shift-Mapping",
      //       showSubRoute: true,
      //       accessCode: "Employee Shift Mapping",
      //     },
      //   ],
      // },
      {
        label: "Claims Processing",
        link: "#",
        icon: <Icon.FileText />,
        submenu: true,
        showSubRoute: false,
        accessCode: "Claims Processing",
        submenuItems: [
          // {
          //   label: "Claim Categories",
          //   link: "/Claim/Type/Claim-Type",
          //   icon: <Icon.Calendar />,
          //   showSubRoute: false,
          //   accessCode: "Claim Categories",
          // },
          {
            label: "Manage Claims",
            link: "/Claim/Manage/Claim-List",
            icon: <Icon.Calendar />,
            showSubRoute: false,
            accessCode: "Manage Claims",
          },
        ],
      },

      // {
      //   label: "Payroll Management",
      //   link: "#",
      //   icon: <Icon.DollarSign />,
      //   showSubRoute: false,
      //   submenu: true,
      //   accessCode: "Payroll Management",
      //   submenuItems: [
      //     {
      //       label: "Payroll Generation",
      //       link: "/Payroll/GeneratePayroll",
      //       showSubRoute: false,
      //       accessCode: "Payroll Generation",
      //     },
      //     {
      //       label: "Payroll Processing Stages",
      //       link: "/Payroll/PayrollStage",
      //       showSubRoute: false,
      //       accessCode: "Payroll Processing Stages",
      //     },
      //     {
      //       label: "Payroll Records",
      //       link: "/Payroll/PayrollList",
      //       showSubRoute: false,
      //       accessCode: "Payroll Records",
      //     },
      //     {
      //       label: "Allowance Management",
      //       link: "/Payroll/Addition",
      //       showSubRoute: false,
      //       accessCode: "Allowance Management",
      //     },
      //     {
      //       label: "Deduction Management",
      //       link: "/Payroll/Deduction",
      //       showSubRoute: false,
      //       accessCode: "Deduction Management",
      //     },
      //   ],
      // },
      // {
      //   label: "Loans & Advances",
      //   link: "#",
      //   icon: <Icon.FileText />,
      //   submenu: true,
      //   showSubRoute: false,
      //   accessCode: "Loans & Advances",
      //   submenuItems: [
      //     {
      //       label: "Advance Disbursement",
      //       link: "/LoanAndAdvance/Advance-Payment/Advance-Payment-List",
      //       icon: <Icon.Calendar />,
      //       showSubRoute: false,
      //       accessCode: "Advance Disbursement",
      //     },
      //   ],
      // },
      // {
      //   label: "Others",
      //   link: "#",
      //   icon: <Icon.FileText />,
      //   submenu: true,
      //   showSubRoute: false,
      //   accessCode: "Vehicle Management",
      //   submenuItems: [
      //     {
      //       label: "Vehicle",
      //       link: "/Master/Vehicle/VehicleInformation",
      //       icon: <Icon.Calendar />,
      //       showSubRoute: false,
      //       accessCode: "Vehicle Registry",
      //     },
      //   ],
      // },
      {
        label: "Reports",
        icon: <Icon.File />,
        link: "/Report/Report-List",
        submenu: false,
        accessCode: "Report",
      },

      // {
      //   label: "Setting",
      //   link: "#",
      //   icon: <Icon.Settings />,
      //   showSubRoute: false,
      //   submenu: true,
      //   accessCode: "Settings",
      //   submenuItems: [
      //     {
      //       label: "Company Settings",
      //       icon: <Icon.Settings />,
      //       link: "/Company/Setting/Company-Setting",
      //       showSubRoute: false,
      //       accessCode: "CompanySetting",
      //     },
      //     {
      //       label: "Email Alert Configuration",
      //       icon: <Icon.Settings />,
      //       link: "/Company/Setting/Email-Alert-Configuration",
      //       showSubRoute: false,
      //       accessCode: "Email Alert Configuration",
      //     },
      //     {
      //       label: "Users",
      //       icon: <Icon.Settings />,
      //       // link: "/Company/Setting/User",
      //       submenu: true,
      //       showSubRoute: false,
      //       accessCode: "Users",
      //       submenuItems: [
      //         // {
      //         //   label: "Employee Login",
      //         //   link: "/Company/Setting/User/Employee-Master/List",
      //         //   showSubRoute: false,
      //         //   accessCode: "Payroll Generation",
      //         // },
      //         {
      //           label: "Users",
      //           link: "/Company/Setting/User/User-Master/List",
      //           showSubRoute: false,
      //           accessCode: "UsersMaster",
      //         },

      //         {
      //           label: "User Groups",
      //           link: "/Company/Setting/User/User-Group/List",
      //           showSubRoute: false,
      //           accessCode: "Users Groups",
      //         },
      //         // {
      //         //   label: "Role Management",
      //         //   link: "/Company/Setting/User/User-Roles",
      //         //   showSubRoute: false,
      //         // },
      //         // {
      //         //   label: "Level 2.2",
      //         //   submenu: true,
      //         //   showSubRoute: false,
      //         //   // submenuItems: [
      //         //   //   { label: "Level 3.1", link: "#", showSubRoute: false },
      //         //   //   { label: "Level 3.2", link: "#", showSubRoute: false },
      //         //   // ],
      //         // },
      //       ],
      //     },
      //     {
      //       label: "Master",
      //       icon: <Icon.Settings />,
      //       link: "/Company/Setting/Master",
      //       showSubRoute: false,
      //       accessCode: "Master",
      //     },
      //     {
      //       label: "Announcement",
      //       link: "/Company/Announcement/AnnouncementList",
      //       icon: <Icon.Calendar />,
      //       showSubRoute: false,
      //       accessCode: "CompanySetting",
      //     },
      //     {
      //       label: "Audit Log",
      //       icon: <Icon.Settings />,
      //       link: "/Company/Setting/Audit-Log",
      //       showSubRoute: false,
      //       accessCode: "CompanySetting",
      //     },
      //   ],
      // },
    ],
  },
];

// import React from "react";
// import * as Icon from "react-feather";
// import { all_routes } from "Router/all_routes";

// export const SidebarData = [
//   {
//     label: "Main",
//     submenuOpen: true,
//     showSubRoute: false,
//     submenuHdr: "Main",
//     submenuItems: [
//       {
//         label: "Dashboard",
//         link: "/Dashboard",
//         icon: <Icon.Grid />,
//         submenu: false,
//         showSubRoute: false,
//         accessCode: "Dashboard",
//       },
//     ],
//   },
//   {
//     label: "HRM",
//     submenuOpen: true,
//     showSubRoute: false,
//     submenuHdr: "EMPLOYEE",
//     submenuItems: [
//       {
//         label: "Employees",
//         link: "#",
//         icon: <Icon.Users />,
//         showSubRoute: false,
//         submenu: true,
//         accessCode: "Departments",
//         submenuItems: [
//           {
//             label: "Employees",
//             link: "/Employee/EmployeeList",
//             icon: <Icon.User />,
//             showSubRoute: false,
//             accessCode: "Employees",
//           },
//           {
//             label: "Departments",
//             link: "/Department/DepartmentList",
//             icon: <Icon.User />,
//             showSubRoute: false,
//             accessCode: "Departments",
//           },
//           {
//             label: "Designations",
//             link: "/Designation/DesignationList",
//             icon: <Icon.UserCheck />,
//             showSubRoute: false,
//             accessCode: "Designation",
//           },

//           {
//             label: "Employee Allowance",
//             link: "/Employee/Allowance",
//             icon: <Icon.User />,
//             showSubRoute: false,
//             accessCode: "Employee Allowance",
//           },
//           {
//             label: "Employee Deductions",
//             link: "/Employee/Deduction",
//             icon: <Icon.UserCheck />,
//             showSubRoute: false,
//             accessCode: "Employee Deductions",
//           },
//         ],
//       },
//       {
//         label: "Leave",
//         link: "#",
//         icon: <Icon.Calendar />,
//         showSubRoute: false,
//         submenu: true,
//         accessCode: "Manage Leave",
//         submenuItems: [
//           {
//             label: "Manage Leave",
//             link: "/Leave/LeaveManagement",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Manage Leave",
//           },
//           {
//             label: "Leave Types",
//             link: "/Leave/LeaveType",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Leave Types",
//           },
//           {
//             label: "Employee Leaves",
//             link: "/Leave/EmployeeLeave",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Employee Leaves",
//           },
//           {
//             label: "Holidays",
//             link: "/Leave/PublicHoliday",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Holidays",
//           },
//         ],
//       },
//       {
//         label: "Attendance",
//         link: "#",
//         icon: <Icon.Clock />,
//         submenu: true,
//         showSubRoute: false,
//         accessCode: "Attendance Management",
//         submenuItems: [
//           {
//             label: "Time Log",
//             // link: "/Attendance/AttendanceManagement",
//             link: "/Attendance/TimeLog",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Attendance Management",
//           },
//           {
//             label: "Attendance Management",
//             // link: "/Attendance/AttendanceManagement",
//             link: "/Attendance/Attendance-Filter",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Attendance Management",
//           },
//           // {
//           //   label: "Shift Policy",
//           //   icon: <Icon.Settings />,
//           //   link: "/Company/Setting/Shift/Shift-Policy",
//           //   showSubRoute: true,
//           // },
//           {
//             label: "Timesheet",
//             link: "/Attendance/Timesheet",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Timesheet",
//           },
//         ],
//       },
//       {
//         label: "Project",
//         link: "#",
//         icon: <Icon.FileText />,
//         submenu: true,
//         showSubRoute: false,
//         accessCode: "Project",
//         submenuItems: [
//           {
//             label: "Project",
//             link: "/Project/Project",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Project",
//           },
//           {
//             label: "Task",
//             link: "/Project/Task",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Task",
//           },
//         ],
//       },
//       {
//         label: "Shift",
//         link: "#",
//         icon: <Icon.Clock />,
//         submenu: true,
//         showSubRoute: false,
//         accessCode: "Project",
//         submenuItems: [
//           {
//             label: "Shift Policy",
//             icon: <Icon.Settings />,
//             link: "/Shift/Shift-Policy",
//             showSubRoute: true,
//             accessCode: "Shift Policy",
//           },
//           {
//             label: "Shift Rotation",
//             icon: <Icon.Settings />,
//             link: "/Shift/Shift-Rotation",
//             showSubRoute: true,
//             accessCode: "Shift Rotation",
//           },
//           {
//             label: "Employee Mapping",
//             icon: <Icon.Settings />,
//             link: "/Shift/Employee-Shift-Mapping",
//             showSubRoute: true,
//             accessCode: "Employee Mapping",
//           },
//         ],
//       },
//       {
//         label: "Claim",
//         link: "#",
//         icon: <Icon.FileText />,
//         submenu: true,
//         showSubRoute: false,
//         accessCode: "Type",
//         submenuItems: [
//           {
//             label: "Type",
//             link: "/Claim/Type/Claim-Type",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Type",
//           },
//           {
//             label: "Manage",
//             link: "/Claim/Manage/Claim-List",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Manage",
//           },
//         ],
//       },

//       {
//         label: "Payroll",
//         link: "#",
//         icon: <Icon.DollarSign />,
//         showSubRoute: false,
//         submenu: true,
//         accessCode: "Generate Payroll",
//         submenuItems: [
//           {
//             label: "Generate Payroll",
//             link: "/Payroll/GeneratePayroll",
//             showSubRoute: false,
//             accessCode: "Generate Payroll",
//           },
//           {
//             label: "Payroll Stage",
//             link: "/Payroll/PayrollStage",
//             showSubRoute: false,
//             accessCode: "Payroll Stage",
//           },
//           {
//             label: "Payroll List",
//             link: "/Payroll/PayrollList",
//             showSubRoute: false,
//             accessCode: "Payroll List",
//           },
//           {
//             label: "Allowance",
//             link: "/Payroll/Addition",
//             showSubRoute: false,
//             accessCode: "Allowance",
//           },
//           {
//             label: "Deductions",
//             link: "/Payroll/Deduction",
//             showSubRoute: false,
//             accessCode: "Deductions",
//           },
//         ],
//       },
//       {
//         label: "Loans & Advances",
//         link: "#",
//         icon: <Icon.FileText />,
//         submenu: true,
//         showSubRoute: false,
//         accessCode: "Type",
//         submenuItems: [
//           // {
//           //   label: "Loans",
//           //   link: "/LoanAndAdvance/Loans/Loans",
//           //   icon: <Icon.Calendar />,
//           //   showSubRoute: false,
//           //   accessCode: "Type",
//           // },
//           {
//             label: "Advance Payment",
//             link: "/LoanAndAdvance/Advance-Payment/Advance-Payment-List",
//             icon: <Icon.Calendar />,
//             showSubRoute: false,
//             accessCode: "Manage",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     label: "Reports",
//     submenuOpen: true,
//     showSubRoute: false,
//     submenuHdr: "Reports",
//     submenuItems: [
//       {
//         label: "Reports",
//         submenuOpen: true,
//         showSubRoute: false,
//         submenuHdr: "Reports",
//         icon: <Icon.File />,
//         link: "#",
//         submenu: true,
//         accessCode: "Report",
//         submenuItems: [
//           {
//             label: "Attendance Report",
//             link: "/Report/Attendance-Report",
//             icon: <Icon.BarChart2 />,
//             showSubRoute: false,
//             accessCode: "Report",
//           },
//           {
//             label: "Leave Report",
//             link: "/Report/Leave-Report",
//             icon: <Icon.PieChart />,
//             showSubRoute: false,
//             accessCode: "Report",
//           },
//           {
//             label: "Monthly Payroll Summary",
//             link: "/Report/Monthly-Payroll-Summary",
//             icon: <Icon.Inbox />,
//             showSubRoute: false,
//             accessCode: "Report",
//           },
//           {
//             label: "Payslip Report",
//             link: "/Report/Payslip-Report",
//             icon: <Icon.File />,
//             showSubRoute: false,
//             accessCode: "Report",
//           },
//           {
//             label: "Forecast Report",
//             link: "/Report/Forecast-Report",
//             icon: <Icon.File />,
//             showSubRoute: false,
//             accessCode: "Report",
//           },
//           {
//             label: "Expiry Report",
//             link: "/Report/Expiry-Report",
//             icon: <Icon.File />,
//             showSubRoute: false,
//             accessCode: "Report",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     label: "Settings",
//     submenu: true,
//     showSubRoute: false,
//     submenuHdr: "Settings",
//     submenuItems: [
//       {
//         label: "Setting",
//         link: "#",
//         icon: <Icon.Settings />,
//         showSubRoute: false,
//         submenu: true,
//         accessCode: "Company Setting",
//         submenuItems: [
//           {
//             label: "Company Settings",
//             icon: <Icon.Settings />,
//             link: "/Company/Setting/Company-Setting",
//             showSubRoute: false,
//             accessCode: "Company Setting",
//           },
//           {
//             label: "Users",
//             icon: <Icon.Settings />,
//             // link: "/Company/Setting/User",
//             submenu: true,
//             showSubRoute: false,
//             accessCode: "Report",
//             submenuItems: [
//               {
//                 label: "Users",
//                 link: "/Company/Setting/User/User-Master/List",
//                 showSubRoute: false,
//                 accessCode: "User Master",
//               },
//               {
//                 label: "User Groups",
//                 link: "/Company/Setting/User/User-Group/List",
//                 showSubRoute: false,
//                 accessCode: "User Group",
//               },
//               // {
//               //   label: "Role Management",
//               //   link: "/Company/Setting/User/User-Roles",
//               //   showSubRoute: false,
//               // },
//               // {
//               //   label: "Level 2.2",
//               //   submenu: true,
//               //   showSubRoute: false,
//               //   // submenuItems: [
//               //   //   { label: "Level 3.1", link: "#", showSubRoute: false },
//               //   //   { label: "Level 3.2", link: "#", showSubRoute: false },
//               //   // ],
//               // },
//             ],
//           },
//           {
//             label: "Master",
//             icon: <Icon.Settings />,
//             link: "/Company/Setting/Master",
//             showSubRoute: false,
//             accessCode: "Acadamics",
//           },
//         ],
//       },

//       // {
//       //   label: "Website Settings",
//       //   submenu: true,
//       //   showSubRoute: false,
//       //   icon: <Icon.Globe />,
//       //   submenuItems: [
//       //     {
//       //       label: "System Settings",
//       //       link: "/system-settings",
//       //       showSubRoute: false,
//       //     },
//       //     {
//       //       label: "Company Settings",
//       //       link: "/company-settings",
//       //       showSubRoute: false,
//       //     },
//       //     {
//       //       label: "Localization",
//       //       link: "/localization-settings",
//       //       showSubRoute: false,
//       //     },
//       //     { label: "Prefixes", link: "/prefixes", showSubRoute: false },
//       //     { label: "Preference", link: "/preference", showSubRoute: false },
//       //     { label: "Appearance", link: "/appearance", showSubRoute: false },
//       //     {
//       //       label: "Social Authentication",
//       //       link: "/social-authentication",
//       //       showSubRoute: false,
//       //     },
//       //     {
//       //       label: "Language",
//       //       link: "/language-settings",
//       //       showSubRoute: false,
//       //     },
//       //   ],
//       // },
//       // {
//       //   label: "App Settings",
//       //   submenu: true,

//       //   showSubRoute: false,
//       //   icon: <Icon.Smartphone />,
//       //   submenuItems: [
//       //     { label: "Invoice", link: "/invoice-settings", showSubRoute: false },
//       //     { label: "Printer", link: "/printer-settings", showSubRoute: false },
//       //     { label: "POS", link: "/pos-settings", showSubRoute: false },
//       //     {
//       //       label: "Custom Fields",
//       //       link: "/custom-fields",
//       //       showSubRoute: false,
//       //     },
//       //   ],
//       // },
//       // {
//       //   label: "System Settings",
//       //   submenu: true,
//       //   showSubRoute: false,
//       //   icon: <Icon.Monitor />,
//       //   submenuItems: [
//       //     { label: "Email", link: "/email-settings", showSubRoute: false },
//       //     { label: "SMS Gateways", link: "/sms-gateway", showSubRoute: false },
//       //     { label: "OTP", link: "/otp-settings", showSubRoute: false },
//       //     {
//       //       label: "GDPR Cookies",
//       //       link: "/gdpr-settings",
//       //       showSubRoute: false,
//       //     },
//       //   ],
//       // },
//       // {
//       //   label: "Financial Settings",
//       //   submenu: true,
//       //   showSubRoute: false,
//       //   icon: <Icon.DollarSign />,
//       //   submenuItems: [
//       //     {
//       //       label: "Payment Gateway",
//       //       link: "/payment-gateway-settings",
//       //       showSubRoute: false,
//       //     },
//       //     {
//       //       label: "Bank Accounts",
//       //       link: "/bank-settings-grid",
//       //       showSubRoute: false,
//       //     },
//       //     { label: "Tax Rates", link: "/tax-rates", showSubRoute: false },
//       //     {
//       //       label: "Currencies",
//       //       link: "/currency-settings",
//       //       showSubRoute: false,
//       //     },
//       //   ],
//       // },
//       // {
//       //   label: "Other Settings",
//       //   submenu: true,
//       //   showSubRoute: false,
//       //   icon: <Icon.Hexagon />,
//       //   submenuItems: [
//       //     { label: "Storage", link: "/storage-settings", showSubRoute: false },
//       //     {
//       //       label: "Ban IP Address",
//       //       link: "/ban-ip-address",
//       //       showSubRoute: false,
//       //     },
//       //   ],
//       // },
//       // {
//       //   label: "Logout",
//       //   link: "/signin",
//       //   icon: <Icon.LogOut />,
//       //   showSubRoute: false,
//       // },
//     ],
//   },
// ];
